import { createAsyncThunk } from '@reduxjs/toolkit';
import { z } from 'zod';

import { LessonTaskStepKeys } from '../../../../main/constants/lesson-task-step-keys.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { LessonEventSchema } from '../../../../main/types/tracking.types.ts';
import { getLessonsUtil } from '../../../../main/utils/asset/lessons.util.ts';
import { getAudioRecordingUtil } from '../../../../main/utils/audio/audio-recording.util.ts';
import { getTrackerUtil } from '../../../../main/utils/trackers/tracker.util.ts';

import { PROGRESS_SLICE_NAME } from '../progress.slice.types.ts';

type LessonEvent = z.infer<typeof LessonEventSchema>;

interface Props {
  event: LessonEvent['event'];
  feedback?: LessonEvent['data']['feedback'];
  answer?: LessonEvent['data']['answer'];
}

const THUNK_NAME = `${PROGRESS_SLICE_NAME}/trackProgressionEventThunk`;

export const trackProgressionEventThunk = createAsyncThunk<void, Props, ThunkApiConfigType>(
  THUNK_NAME,
  (props, thunkAPI) => {
    const { event, answer, feedback } = props;

    const state = thunkAPI.getState();
    const {
      lesson: lessonNumber,
      task: taskNumber,
      step: stepNumber,
    } = state.lesson.currentLessonTaskStepKey ?? LessonTaskStepKeys.DEFAULT_CURRENT;
    const { task, step } = getLessonsUtil().getLessonTaskStep({
      lesson: lessonNumber,
      task: taskNumber,
      step: stepNumber,
    })!;

    const recordingKey = getAudioRecordingUtil().getRecordingKey();

    getTrackerUtil().track({
      event,
      data: {
        lessonNumber,
        taskNumber,
        taskType: task.taskType,
        stepNumber,
        stepType: step.stepType,
        answer: answer ?? step.answer,
        recordingKey,
        feedback,
      },
    });
  }
);
